
(function() {

	var Container=include("PIXI.Container"),
	Sprite=include("PIXI.Sprite"),
    Graphics = include("PIXI.Graphics"),
	Text=include("PIXI.Text"),
	Point=include("PIXI.Point"),
	DisplayAdapter=include("springroll.pixi.DisplayAdapter"),
	Tween=include("createjs.Tween"),
	Timeline=include("createjs.Timeline"),
	Ease=include("createjs.Ease"),
	GenericMovieClipInstance=("springroll.GenericMovieClipInstance"),
	AnimatorInstance=("springroll.AnimatorInstance"),
	
	EventDispatcher=include('springroll.EventDispatcher');

	var RuffWheel=function(options) {
		
		// options are frame {x,y,w,h}, voplayer (optional)
		this.init(options);
	};

	var p = extend(RuffWheel, AnimatorInstance);
	var myjson;

	RuffWheel.makeMovieClipFromZoeSpritesheet=function(cjsspritesheet,animationname,framerate) {
		/* clip config is maybe ZOE-style/createjs spritesheet? Makes it a bit easier...

			the spritesheet config looks like 
			{
				images:[imagename,...],
				frames:[[x,y,w,h,index,xoffset,yoffset],...],
				animations{
				"animname":ANIMCONFIG,...
				}
			}

		  ANIMCONFIG is either
		  	1) a single index number for a frame
		  	2) an array of at least 2 and up to 4, corresponding with [startframe, endframe, nextanimationname, speed]
		  	3) an object with specifically named properties for "frames":[1,4,5,6,7,8,9] (all frame indices), "next":nextanimationname, "speed":speed
		  
		  I think Zoe usually does #3, so stick with that.
		  
			assume images are loaded already!
			assuming only one image file for the entire spritesheet!		
		*/

		
		// make pixi textures out of the image
		
		if(!animationname) {
			// whatever default is.
		}
		
		var framelist=cjsspritesheet.animations[animationname].frames;
		var fn=framelist.length;
		var textures=[];
		var rects=[];
		var offsets=[];
		for(var i=0;i<fn;i++) {
			var frameinfo=cjsspritesheet.frames[framelist[i]];
			var frameindex=(frameinfo[4])?frameinfo[4]:0;
			var imageid=cjsspritesheet.images[frameindex];
			// strip the .png from the end
			if(!images[imageid]) {
				images[imageid]=PIXI.Texture.fromImage(imageurls[imageid]);
			}
			var basetx=images[imageid];
			var tx=images[imageid];
			
			var texture=basetx.clone();
			
			texture.frame=new PIXI.Rectangle(frameinfo[0],frameinfo[1],frameinfo[2],frameinfo[3]);
			
			rects.push(new PIXI.Rectangle(frameinfo[0],frameinfo[1],frameinfo[2],frameinfo[3]));
			offsets.push(new Point(frameinfo[5]*-1,frameinfo[6]*-1));
			textures.push(texture);
		}
		var txt=PIXI.Texture.fromImage(imageurls[cjsspritesheet.images[0]]); // pull just the first (only!) image in the array
		var mc=new Container();
		mc.sprite=new Sprite(txt);
		mc.addChild(mc.sprite);
		mc.sprite.texture=txt.clone();
		mc.frames=rects;
		mc.offsets=offsets;
		mc.ind=0;
		mc.threshold=60;
		mc.tcount=0;
		mc.stopped=true;

		mc.startloop=function() {
			this.loop=true;
			this.once=false;
			this.play();
		};

		mc.setframerate=function(fps) {
			this.threshold=parseInt(1000/fps);
		};

		mc.doonce=function() {
			this.once=true;
			this.play();
		};

		mc.update=function(tin) {
			if(this.stopped || !tin) return;
			this.tcount=tin+this.tcount;
			if(this.tcount < this.threshold) return;
			this.tcount=0;
			this.ind=this.ind+1;
			if(this.ind >= this.frames.length) {
				if(this.loop) {
					this.ind=0;
				} else if(this.once) {
					this.stop();
					//this.update=null;
					this.events.trigger('done',this);
					app.off('update',this.update);
					return;
				} else {// no loop and also not once - what then?				
					app.off('update',this.update);
					this.done=true;
				}
			}
			this.doframe(this.ind);
		};
		
		
		
		mc.doframe=function(ind) {
			this.ind=ind;
			this.sprite.texture.frame=this.frames[ind];
			this.sprite.position.x=this.offsets[ind].x;
			this.sprite.position.y=this.offsets[ind].y;
		};
		
		mc.play=function(count) {
			app.off('update',this.update);
			app.on('update',this.update);
			this.events=new EventDispatcher();
			this.events.clip=this;
			this.stopped=false;
		};
		
		mc.stop=function() {
			app.off('update',this.update);
			this.stopped=true;
		};
		
		mc.gotoAndStop=function(ind) {
			app.off('update',this.update);
			this.doframe(ind);
		};

		mc.gotoAndPlay=function(ind) {
			this.ind=ind-1;
			this.play();
		};
		
		if(framerate) mc.setframerate(framerate);
		mc.doframe(0);		
		mc.update=mc.update.bind(mc);
		return mc;
	};
	
	p.init=function(options) {
		//Container.call(this);
		this.visual=new Container();
		myjson=app.config.ruffwheel.spritesheet;
		var tweens=[];
		var labels={onTransitionOut:1,onTransitionOut_stop:30,onTransitionIn:50,onTransitionIn_stop:79};
		var properties={loop:true};
		this.timeline=new Timeline(tweens,labels,properties);
		
		var gr=new Graphics();
		
        gr.beginFill(UIPanel.colorfromhex("#ffffff"), 1);
		gr.drawRect(
            -171,
            0,
            1366,
            768
          );
        gr.endFill();
        
        this.visual.addChild(gr);
		this.allruff=new Container();
		this.bar=RuffWheel.makeMovieClipFromZoeSpritesheet(myjson,'bar');
		this.bar.position={x:285,y:200};
		this.bar.sprite.anchor={x:0.5,y:0.5};
		this.allruff.position={x:300,y:200};
		this.allruff.addChild(this.bar);
		var me=this;
		app.on('update',function() {me.bar.rotation=me.bar.rotation+0.1;});
		this.wheel=RuffWheel.makeMovieClipFromZoeSpritesheet(myjson,'wheel');
		this.allruff.addChild(this.wheel);
		this.wheel.setframerate(24);
		this.wheel.startloop();
		this.ruff=RuffWheel.makeMovieClipFromZoeSpritesheet(myjson,'ruff');
		this.ruff.position={x:30,y:40};
		this.ruff.setframerate(8);
		this.ruff.startloop();
		this.allruff.addChild(this.ruff);
		this.visual.addChild(this.allruff);
	};
	
// needs to act a bit like a movieclip to be a transition: getlabels, gotoAndStop, getCurrentLabel, getEvents, copyFrom, destroy, advance
	p.pplay=function() {
	
	};
	
	p.pgotoAndPlay=function(place) {
	
	};
	
	p.pupdate=function() {
	
	};
	
	p.penter=function() {
		this.visual.visible=true;
	//	Tween.get(this.visual.position).to({x:200,y:0},1500);
	};

	p.pmiddle=function() {
		
	};
	
	p.pexit=function() {
		var me=this;
		this.visual.visible=false;
	//	Tween.get(this.visual.position).to({x:800,y:0},1500).call(function() {me.visual.visible=false;
	//	me.position={x:-80,y:0};});
	};
	
	p.padvance=function() {
	};
	
	p.pdone=function() {
		//this.visible=false;
		//this.position={x:0,y:0};
	};
	



	namespace('WGBH.pixi').RuffWheel = RuffWheel;

})();